// =============================================================================
// Admin Dashboard
//
// Top level admin page. Composes SystemCredentials and ClientManagement panels.
// Access is gated at the route level via AdminRoutes.tsx.
// =============================================================================

import { FunctionComponent } from "react";
import { ADMIN_DASHBOARD } from "src/constants/adminDashboard";
import SystemCredentials from "./system-credentials";
import ClientManagement from "./client-management";

const AdminDashboard: FunctionComponent = () => (
  <div className="p-8 flex flex-col gap-8 w-full">
    <div>
      <h1 className="text-2xl font-bold text-gray-900">{ADMIN_DASHBOARD.title}</h1>
      <p className="text-sm text-gray-500 mt-1">{ADMIN_DASHBOARD.subtitle}</p>
    </div>
    <SystemCredentials />
    <ClientManagement />
  </div>
);

export default AdminDashboard;

